<template>
    <div>
        <p class="title"> {{title}} </p>
        <v-select ref="vselect" v-model="selectedOption" :options="optionsList" :label="label" :onChange="(value) => this.$emit('onChange', value)" :class="classDef" :disabled="disabled" :clearable="clearable"/>
        <p class="desc" v-if="errorMode === ''">{{ description }}</p>
        <p class="error" v-if="errorMode !== ''" style="font-size: 13px; font-weight: bold; border: none; color: rgb(218, 97, 97);">{{ errorMode }}</p>
    </div>
</template>

<script>
export default {
    name: 'Select',
    props: {
        selected: {},
        options: {},
        title: {},
        description: {},
        label: {},
        disabled: {},
        selectClass: {},
        errorMode: {
            type: String,
            default: ''
        },
        clearable: {
            default: true
        }
    },
    watch: {
        selected: function(newVal, oldVal) {
            this.selectedOption = newVal;
        },
        options: function(newVal, oldVal) {
            this.optionsList = newVal;
        }
    },
    methods: {
        onChange() {
        }
    },
    components: {

    },
    computed: {
        classDef() {
            return this.errorMode === '' ? `select ${this.selectClass}` : `error ${this.selectClass}`;
        },
    },
    mounted: function () {
    
    },
    data() {
        return {
            selectedOption: this.selected,
            optionsList: this.options
        }
    },
    created() {

    }
}
</script>

<style>
/*.v-select .dropdown-toggle .clear { visibility: hidden; }*/
.v-select .dropdown-toggle .clear
{
    margin-top: 4px;
    color: #0095B2 !important;
}
.v-select .open-indicator:before {
    border-color: #0095B2 !important;
}

.v-select.disabled .dropdown-toggle input {
    background-color: transparent !important;
    cursor: default !important;
}
/*
.v-select .dropdown-toggle {
  border: 1px solid #A3D4E0 !important;
}
*/

.select-error {
    border: 1px solid #A3D4E0;
}
.select {
    border: 1px solid #A3D4E0;
}

.v-select.disabled .dropdown-toggle,
.v-select.disabled .dropdown-toggle .clear,
.v-select.disabled .dropdown-toggle input,
.v-select.disabled .open-indicator,
.v-select.disabled .selected-tag .close
.form-control[disabled] {
    cursor: default !important;
}
</style>

<style scoped>

.v-select {
    width: 100%;
    color: black;
    box-sizing: border-box;
    border-radius: 5px;
    height: 35px;
    font-size: 14px;
    font-family: 'SourceSansProRegular', sans-serif !important;
}

.title {
    width: 160px;
    font-family: 'SourceSansProSemiBold', sans-serif !important;
    font-weight: bold;
    font-size: 14px;
    margin: 0;
}

.desc {
    font-style: italic;
    font-size: 13px;
    color: rgb(96, 107, 108);
}

.error {
    font-weight: bold;
}

.v-select.disabled {
    border: none !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Select.vue